export const container = `
  w-[135px] lg:w-[150px]
  py-3 px-2
  rounded-lg
  shadow-lg
  bg-white
  border-2
  border-ll-primary
  flex flex-col
  gap-1
  text-xs
  font-ll-on-surface
`;

export const iconContainer = `
  flex
  items-center justify-center
  h-6 w-6
  rounded-3xl
  bg-ll-surface-variant1
`;

export const icon = `
  text-ll-primary
  w-3 h-3
`;

export const title = `
  text-inherit
  font-semibold
  font-ll-on-surface
  data-[has-url=true]:text-ll-primary
`;

export const description = `
  text-inherit
  font-ll-on-surface
`;

export const schoolAttributeInfo = `
  m-0 p-0 leading-4
`;
